import _ from 'lodash';
import { faPlane } from '@fortawesome/pro-solid-svg-icons/faPlane';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import ExpandableProfileCard from 'components/customer/profile/expandable_profile_card';
import ExpandedFlightTransactionHeader, { FlightAttributesPropTypes } from './expanded_flight_transaction';
import FlightTransactionDot from './flight_transaction_dot';
import { FlightTransactionDef, TransactionDefType } from 'models/configuration/transaction_def';
import ProfileCardDef from 'models/configuration/profile_card_def';
import TransactionGroup from './transaction_group';
import Tooltip from 'components/common/tooltip';

export class FlightTransactionSummary extends React.PureComponent {
  render() {
    const { attributes } = this.props;
    return (
      <div className="flightTransaction-summary">
        {this.renderStatus()}
        <div className="flightTransaction-flightNumber">{attributes.flightNumber}</div>
        <div className="flightTransaction-originDestination">
          <div className="flightTransaction-origin">{attributes.origin}</div>
          <div className="flightTransaction-flightIcon">
            <FontAwesomeIcon icon={faPlane} />
          </div>
          <div className="flightTransaction-destination">{attributes.destination}</div>
        </div>
        <span className="flightTransaction-departure">{this.renderDepartureContent()}</span>
      </div>
    );
  }

  renderStatus() {
    const { attributes, transactionDef } = this.props;
    return (
      <div className="flightTransaction-status-wrapper">
        <div className="flightTransaction-status">
          <Tooltip bounds={{ left: 10 }} position="top" message={attributes.status || 'Unknown status'}>
            <FlightTransactionDot status={attributes.status} statusCodeMap={transactionDef.statusCodeMap} />
          </Tooltip>
        </div>
      </div>
    );
  }

  renderDepartureContent() {
    const { attributes } = this.props;
    let departureContent;
    if (!attributes.departureTime) {
      departureContent = <div className="flightTransaction-departureUnavailable">N/A</div>;
    } else {
      const departureDate = moment(attributes.departureTime).format('MMM D');
      const departureTime = moment(attributes.departureTime).format('h:mm A');
      departureContent = [
        <div key="date" className="flightTransaction-departureDate">
          {departureDate}
        </div>,
        <div key="time" className="flightTransaction-departureTime">
          {departureTime}
        </div>,
      ];
    }
    return departureContent;
  }
}

FlightTransactionSummary.propTypes = {
  attributes: FlightAttributesPropTypes,
  transactionDef: PropTypes.instanceOf(FlightTransactionDef),
};

export default function FlightTransactions({ isLoading, transactionDef, transactions, onExpand, profileCardDef }) {
  const flightTransactionGroupMap = _(transactions)
    .groupBy('attributes.pnrCode')
    .value();

  const flightTransactionGroups = _(flightTransactionGroupMap)
    .map((groupTransactions, pnrCode) => {
      return [pnrCode, groupTransactions];
    })
    .sortBy(([pnrCode, groupTransactions]) => groupTransactions[0].attributes.departureTime)
    .value();

  const numGroups = _.keys(flightTransactionGroups).length;

  return (
    <ExpandableProfileCard
      title={_.get(profileCardDef, 'label') || `${numGroups} Reservation${numGroups === 1 ? '' : 's'}`}
      isEmpty={!numGroups}
      isLoading={isLoading}
      limit={2}
    >
      {_.map(flightTransactionGroups, ([pnrCode, groupTransactions]) => (
        <TransactionGroup
          key={pnrCode}
          onExpand={onExpand}
          groupClassName="flightTransaction-groupHeader"
          groupName={pnrCode}
          transactions={groupTransactions}
          transactionDef={transactionDef}
          headerRenderer={attributes => (
            <ExpandedFlightTransactionHeader attributes={attributes} transactionDef={transactionDef} />
          )}
          summaryRenderer={attributes => (
            <FlightTransactionSummary attributes={attributes} transactionDef={transactionDef} />
          )}
          type={TransactionDefType.FLIGHT}
        />
      ))}
    </ExpandableProfileCard>
  );
}

FlightTransactions.propTypes = {
  isLoading: PropTypes.bool,
  onExpand: PropTypes.func,
  profileCardDef: PropTypes.instanceOf(ProfileCardDef),
  transactionDef: PropTypes.instanceOf(FlightTransactionDef),
  transactions: PropTypes.arrayOf(PropTypes.shape({ attributes: FlightAttributesPropTypes })),
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/transactions/flight_transactions.jsx